import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';

/**
 * TransferOwnershipDialog
 * – Confirmation dialog to prevent accidental ownership transfers.
 *
 * Props:
 *   open       : boolean
 *   onClose    : () => void
 *   onConfirm  : () => void | Promise<void>
 *   targetUser : user object (expects at least { email })
 */
const TransferOwnershipDialog = ({ open, onClose, onConfirm, targetUser }) => {
  if (!targetUser) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="transfer-ownership-title"
      aria-describedby="transfer-ownership-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="transfer-ownership-title">
        Transfer ownership?
      </DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography id="transfer-ownership-description" variant="body1">
            You&apos;re about to transfer organization ownership to{' '}
            <strong>{targetUser.email}</strong>.
          </Typography>
        </Box>
        <Box mb={2}>
          <Typography variant="body2">
            After this change:
          </Typography>
          <ul>
            <li>
              <Typography variant="body2">
                The new owner will gain full owner permissions.
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                Your account will be downgraded to <strong>admin</strong>.
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                Only the new owner will be able to transfer ownership again.
              </Typography>
            </li>
          </ul>
        </Box>
        <Typography variant="body2" color="error">
          This action cannot be undone from the UI. You&apos;ll need to ask the
          new owner or support to change it back.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
        >
          Confirm transfer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferOwnershipDialog;
